:host {
    display: block;
    position: absolute;
    inset: 0;
    border-radius: inherit;
    overflow: hidden;
    pointer-events: none;
    z-index: 0;
}

.ripple-container {
    position: absolute;
    inset: 0;
}

.ripple {
    position: absolute;
    border-radius: 50%;
    background-color: currentColor;
    opacity: 0.10;

    transform: translate(-50%, -50%) scale(0);

    animation: ripple-enter 0.4s cubic-bezier(0.8, 0.5, 0.5, 0.8) forwards;
}

@keyframes ripple-enter {
    100% {
        transform: translate(-50%, -50%) scale(2.5);
        opacity: 0;
    }
}